import { render, staticRenderFns } from "./BuilderResetButton.vue?vue&type=template&id=461c4118&scoped=true&"
import script from "./BuilderResetButton.vue?vue&type=script&lang=js&"
export * from "./BuilderResetButton.vue?vue&type=script&lang=js&"
import style0 from "./BuilderResetButton.vue?vue&type=style&index=0&id=461c4118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c4118",
  null
  
)

export default component.exports